var fns = {
    //ABOVE
    goAbove: function ($elm, offset) {
        var pos = $elm.parent()[0].getBoundingClientRect(),
            hei = $elm.outerHeight(),
            offset = offset || 0;

        return ((pos.bottom + hei + offset) > $(window).height() && (pos.top - hei) > offset);
    },

    isTouchDevice: function () {
        return (('ontouchstart' in window) ||
            (navigator.maxTouchPoints > 0) ||
            (navigator.msMaxTouchPoints > 0));
    },

    leadingeZero: function (n) {
        return n > 9 ? "" + n : "0" + n;
    },

    randomIntFromInterval: function (min, max) { // min and max included
        return Math.floor(Math.random() * (max - min + 1) + min)
    },

    //PRELOAD
    preload: function (imageArray, index, callback) {
        index = index || 0;
        if (imageArray && imageArray.length > index) {
            var img = new Image();
            img.onload = function () {
                preload(imageArray, index + 1, callback);
            }
            img.src = imageArray[index];
        } else {
            if (typeof callback == 'function') {
                callback();
            }
        }
    },

    create_range: function () {
        var arr = [];
        for (let i = 0; i <= 1.0; i += 0.01) {
            arr.push(i);
        }
        return arr;
    },

    youtube_parser: function (url) {
        var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
        var match = url.match(regExp);
        return (match && match[7].length == 11) ? match[7] : false;
    }

};

var st, $html, yt_ready = false, ytplayer;

$(function () {

    // document.querySelector(".imp-object-spot").innerHTML = '';


    var $window = $(window),
        $body = $('body'),
        lastScrollTop = 0,
        $header = $('.header_inner'),
        header_height = $header.height(),
        is_scrolled = false,
        is_scrolling = false,
        ww = $window.width(),
        wh = $window.height(),
        animdelay_time = 100,
        animdelay_count = 0,
        animdelay;

    st = $window.scrollTop();
    $html = $('html');


    function draggableMap() {
        let bigImage = document.querySelector(".drag")
        if (bigImage) {
            if (ww < 768) {
                let center = bigImage.dataset.center

                let bigDraggable = Draggable.create(bigImage, {
                    type: "x",
                    inertia: true,
                    bounds: ".move_wrapper",
                })[0];

                let options;

                if (center) {
                    options = {
                        x: (bigDraggable.minX + bigDraggable.maxX) / 2,
                        y: (bigDraggable.maxY)
                    }
                } else {
                    options = {
                        x: (bigDraggable.maxX),
                        y: (bigDraggable.maxY)
                    }
                }
                gsap.set(bigImage, options);


                bigDraggable.update();
            } else {
                bigImage.removeAttribute("style");
            }
        }
    }

    draggableMap()

    addEventListener('resize', draggableMap);


    //OBSERVER
    var observer = new window.IntersectionObserver(function (entries, self) {
        entries.forEach(function (entry) {

            if (entry.isIntersecting) {

                if ($(entry.target).hasClass('isvideo')) {
                    console.log(entry.intersectionRatio);
                    if ((entry.intersectionRatio >= .5)) {
                        entry.target.play();
                    } else {
                        entry.target.pause();
                    }
                } else {
                    if ((entry.intersectionRatio == 1 && $(entry.target).hasClass('observe_full')) || !$(entry.target).hasClass('observe_full')) {
                        $(entry.target).addClass('intersecting');
                        self.unobserve(entry.target);

                        if (entry.intersectionRatio == 1 && $(entry.target).hasClass('observe_full')) {
                            $('.observe_sub', $(entry.target)).each(function () {
                                observer.observe($(this)[0]);
                            });
                        }

                        if ($(entry.target).hasClass('anim_delay')) {
                            clearTimeout(animdelay);
                            animdelay_count++;

                            $(entry.target).css('animation-delay', (animdelay_count * animdelay_time) + ($(entry.target).data('animdelay-offset') || 0) + 150 + 'ms');
                            $(entry.target).css('--animation-delay', (animdelay_count * animdelay_time) + ($(entry.target).data('animdelay-offset') || 0) + 150);

                            animdelay = setTimeout(function () {
                                animdelay_count = 0;
                            }, 55);
                        }

                        if ($(entry.target).hasClass('set_delay')) {
                            $(entry.target).css('animation-delay', ($(entry.target).data('animdelay-offset') || 0) + 150 + 'ms');
                        }
                    }
                }
            }
        });
    }, {"threshold": [0, .5, 1]});

    $('.observe').each(function () {
        observer.observe($(this)[0]);
    });

    //OBSERVER
    var headerobserve = new window.IntersectionObserver(function (entries, self) {
        entries.forEach(function (entry) {

            if (entry.isIntersecting) {
                $html.removeClass('fixheader');
            } else {
                $html.addClass('fixheader');
            }

        })
    });

    headerobserve.observe($('.header_sentinel')[0]);
    //OBSERVER
    var cardobserve = new window.ResizeObserver(function (entries, self) {
        entries.forEach(function (entry) {
            if (((entry.contentRect.height - header_height) < wh) && ww > 768) {
                entry.target.classList.add('sticked');
            } else {
                entry.target.classList.remove('sticked');
            }
        })
    });

    $('.card').each(function () {
        cardobserve.observe($(this)[0]);
    });

    //WIN SCROLL
    $window.on('resize', function () {
        wh = $window.height();
        ww = $window.width();
        header_height = $header.height();
    }).trigger('resize');

    //WIN SCROLL
    $window.on('scroll', function () {
        st = $window.scrollTop();
        if (st < 0) st = 0;
        scrolled();

        if (st > lastScrollTop || st == 0) {
            $body.removeClass('scrollup');
        } else {
            if ((st - lastScrollTop) < -5) {
                $body.addClass('scrollup');
            }
        }
        lastScrollTop = st;
    }).trigger('scroll');


    //SCROLLED
    function scrolled() {
        if ($window.scrollTop() > 0) {
            if (!is_scrolled) {
                is_scrolled = true;
                $body.addClass('scrolled');
            }
        } else {
            if (is_scrolled) {
                is_scrolled = false;
                $body.removeClass('scrolled');
            }
        }
    }

    //SLIDER
    $('.slider-custom').each(function () {
        var $this = $(this);

        if ($this.hasClass('slider-img-preload')) {
            preload($('img', $this).map(function () {
                return $(this).attr('src')
            }), 0, function () {
                createSlider($this);
            });
        } else {
            createSlider($this);
        }
    });

    //SLIDER
    $('.slider-custom2').each(function () {
        var $this = $(this);
        let element = $this[0];
        let parent = $this.parent();

        let options = {
            slidesPerView: "auto",
            scrollbar: {
                el: element.querySelector('.swiper-scrollbar'),
                draggable: true,
            },
            navigation: {
                nextEl: element.querySelector('.custom-button-next') ? element.querySelector('.custom-button-next') : document.querySelector('.custom-button-next')
                ,
                prevEl: element.querySelector('.custom-button-prev') ? element.querySelector('.custom-button-prev') : document.querySelector('.custom-button-prev')
                ,
                disabledClass: 'disabled'
            },
        };

        options = $.extend(true, options, $this.data('options'));

        const swiper = new Swiper(element, options);
    });

    //SLIDER
    $('.slider-custom3').each(function () {
        var $this = $(this);
        let element = $this[0];

        let options = {
            slidesPerView: 'auto',
            spaceBetween: 20,
            loop: true,
            centeredSlides: true,
            autoplay: {
                delay: 3000,
                disableOnInteraction: false, 
            },
            loopedSlides: 4,
            speed: 1000, 
            grabCursor: true,
        };

        const swiper = new Swiper(element, options);
    });

    //Slider testimonials
    $('.slider-testimonials').each(function () {
        var $this = $(this);
        let element = $this[0];

        let options = {
            slidesPerView: 1,
            centeredSlides: true,

            navigation: {
                nextEl: element.querySelector('.custom-button-next') ? element.querySelector('.custom-button-next') : document.querySelector('.custom-button-next')
                ,
                prevEl: element.querySelector('.custom-button-prev') ? element.querySelector('.custom-button-prev') : document.querySelector('.custom-button-prev')
                ,
                disabledClass: 'disabled'
            },
            speed: 1000, 
            grabCursor: true,
        };

        const swiper = new Swiper(element, options);
    });

    //CLICKERs
    $('.clicker').clicker();

    //GALLERY
    $('[data-fancy-gallery]').each(function () {
        var $this = $(this),
            data = $this.data('fancy-gallery');

        $('[data-fancy-index]', $this).on('click', function (e) {
            e.preventDefault();
            var lightbox = new Fancybox(data, {startIndex: $(this).data('fancy-index')});
        });
    });

    Fancybox.bind();


    //TOGGLE MENU
    $('.toggle-menu').on('click', function (e) {
        e.preventDefault();

        if ($html.hasClass('menuopen')) {
            $html.removeClass('menuopen').addClass('closemenu');
        } else {
            $html.addClass('menuopen').removeClass('closemenu');
        }

        $('.toggle-menu-element').one('transitionend', function () {
            $(this).off('transitionend');
            $html.removeClass('closemenu');
        });
    });


    if ($('.marquee').length) $('.marquee')[0].style.setProperty("--marquee-speed", Math.round($('.marquee_item span').eq(0).text().length * 2) + 's');

});


(function () {
    var unlock = function (form) {
        clearTimeout(form._wfLockTimer);
        delete form.dataset.wfLocked;
    };

    document.addEventListener('submit', function (e) {
        var form = e.target;

        if (!form.matches || !form.matches('.wpcf7-form')) return;

        if (form.dataset.wfLocked || form.classList.contains('submitting')) {
            e.preventDefault();
            e.stopImmediatePropagation();
            return;
        }

        form.dataset.wfLocked = '1';
        form._wfLockTimer = setTimeout(function () { unlock(form); }, 15000);
    }, true);

    document.addEventListener('wpcf7submit', function (e) {
        unlock(e.target);
    }, true);
})();

//CREATE SLIDER
function createSlider($this) {

    if ($this.hasClass('slider-ready')) {
        return false;
    }

    var obj = {},
        $par = $this.parent();

    options = {
        loop: true,
        speed: 1000,
        slidesPerView: 'auto',
        spaceBetween: 0
    },
        optionsFade = {
            effect: 'fade'
        },
        optionsCenter = {
            centeredSlides: true,
        },
        settings_obj = $this.data('swiper-settings');

    $.extend(true, obj, options);

    if (typeof settings_obj === 'object' && settings_obj !== null) {

        $.extend(true, obj, settings_obj);

        if (settings_obj.fade) {
            $.extend(true, obj, optionsFade);
        }

        if (settings_obj.center) {
            $.extend(true, obj, optionsCenter);
        }
    }

    if (obj.pagination) {
        obj.pagination.clickable = true;
    }

    if (obj.closestPagination) {
        var cpag = $par.find('.pagination');
        obj.pagination.el = cpag[0];
    }

    if (obj.closestScrollbar) {
        obj.scrollbar = {};
        obj.scrollbar.el = $par.find('.swiperscrollbar');
        obj.scrollbar.hide = false;
        obj.scrollbar.draggable = true;
    }

    if (obj.closestNavigation) {
        obj.navigation = {
            "nextEl": $('.swiper-next', $this.closest(obj.closest))[0],
            "prevEl": $('.swiper-prev', $this.closest(obj.closest))[0]
        };
    }

    //INIT SLIDER
    var slider = new Swiper($this[0], obj);

    $this
        .addClass('slider-ready')
        .data('swiper', slider);

    if (obj.mirror) {

        $.each(obj.mirror, function (i, v) {
            var $mirror = $(v);

            var data = $mirror.data('swiper-settings');

            if (data.autoplay) {
                data.autoplay = false;
                $mirror.data('swiper-settings-autoplaymirror', true);
                $mirror.data('swiper-settings', data);
            }

            createSlider($mirror, true);
        });

        $this.data('swiper').on('slideChangeTransitionStart', function () {

            var indx = $this.data('swiper').realIndex,
                func = (obj.loop) ? 'slideToLoop' : 'slideTo';

            if (!$this.data('swiper-pauseMirrorEvent')) {
                $.each(obj.mirror, function (i, v) {
                    var $mirror = $(v);
                    $mirror.data('swiper-pauseMirrorEvent', true);
                    $mirror.data('swiper')[func](indx, $this.data('swiper').passedParams.speed, false);
                    $mirror.data('swiper-pauseMirrorEvent', false);
                });
            }
        });

    }
}

/*CLICKER PLUGIN*/
(function ($) {

    $.fn.clicker = function (method) {

        this.each(function () {
            create_clicker($(this));
        });

        function create_clicker($elm) {

            $elm.on('click.clicker', function (e) {
                e.preventDefault();

                var cd = 'cdone',
                    cm = this.dataset.class || 'cactive',
                    par = this.parentNode,
                    rcp = function (event) {
                        if (!par.contains(event.target)) {
                            par.classList.remove(cm);
                            par.classList.remove(cd);
                            document.removeEventListener('mousedown', rcp);
                        }
                    };

                if (par.classList.contains(cm)) {
                    par.classList.remove(cm);
                    par.classList.remove(cd);
                    document.removeEventListener('mousedown', rcp);
                } else {
                    par.classList.add(cm);
                    par.offsetHeight;
                    par.classList.add(cd);
                    document.addEventListener('mousedown', rcp);

                    if ($elm.data('focus')) {
                        if ($elm.data('focus-trans')) {
                            $html.addClass('disable-scroll-behave');
                            $($elm.data('focus-trans')).off('transitionend');
                            $($elm.data('focus-trans')).one('transitionend', function () {
                                $($elm.data('focus')).focus();
                                $html.removeClass('disable-scroll-behave');
                            });
                        } else {
                            $html.addClass('disable-scroll-behave');
                            $($elm.data('focus')).focus();
                            $html.removeClass('disable-scroll-behave');
                        }
                    }
                }
            });
        }
    }

}(jQuery));

